import { render } from "./MyCards.vue?vue&type=template&id=6a082b6c&ts=true"
import script from "./MyCards.vue?vue&type=script&lang=ts"
export * from "./MyCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__